/* unplugin-vue-components disabled */import script from "./ImageDialog.vue?vue&type=script&setup=true&name=BgImageDialog&lang=js"
export * from "./ImageDialog.vue?vue&type=script&setup=true&name=BgImageDialog&lang=js"

import "./ImageDialog.vue?vue&type=style&index=0&id=6b82f48b&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b82f48b"]])

export default __exports__